import React, { useState, useEffect } from 'react';
import { Row, Col, Table, Form } from 'react-bootstrap';
import Media from 'react-media';
import { ExperienceTableHead } from './ExperienceTableHead';
import NoContent from '../../../reusableComponents/NoContentComponent';
import ExpRequestBodyCard from './ExpRequestBodyCard';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { amApi } from '../../../../api/apiHelper';
import ExpDashboardIcons from './ExpDashboardIcons';
import ExpRequestBodyCardMobile from './ExpRequestBodyCardMobile';
import { SmallLoader } from '../../../Loader/SmallLoader';
import { successAlert } from '../../../../function/alert';
import TableSizePopup from '../../../reusableComponents/allPopupReusable/tableNumberPopup/TableSizePopup';
import PaxFilter from '../../../reusableComponents/paxFilter';
import _ from 'lodash';
import sortAlphaNumeric from '../../../../function/sortAlphaNumeric';
import moment from 'moment';
import AllIcon from '../../../../assets/images/Orders/ordersall.png';
import SearchBar from '../../../reusableComponents/SearchBar';
import StatusFilter from './Modals/StatusFilter';
import BasicPagination from '../../../Pagination/Pagination';
import filterDinnersByPax from '../../../../function/experiencePaxFilter';

const seatingNew = require('../../../../assets/images/seatingImages/specialexp.png');
const pendingNew = require('../../../../assets/images/seatingImages/pendingexp.png');
const historyNew = require('../../../../assets/images/seatingImages/curatedexp.png');
const histNew = require('../../../../assets/images/seatingImages/historyexp.png');

const ExperienceDashboard = () => {
  const [expRequests, setExpRequests] = useState(null);
  const history = useHistory();
  const [isActive, setActive] = useState(false);
  const [search, setSearch] = useState('');
  const paxOptions = [2, 4, 6, 8, 'All'];
  const [paxFilter, setPaxFilter] = useState(null);
  const [groupByData, setGroupByData] = useState({ show: false });
  const [pageNo, setPageNo] = useState(1);
  const [dataCount, setDataCount] = useState(0);
  const [paymentMethod, setPaymentMethod] = useState('');
  const [paymentStatus, setPaymentStatus] = useState('');
  const [expStatus, setExpStatus] = useState('');
  const scanData = history.location.state?.scanData;
  const page = history?.location?.pathname.split('/').pop();
  const [count, setCount] = useState(1);

  const [iconData, setIconData] = useState([
    {
      count: 0,
      link: `/experienceDashboard/pending`,
      icon: pendingNew,
      code: 'pending',
      name: 'Pending',
      showNotification: true,
    },
    {
      count: 0,
      link: `/experienceDashboard/all`,
      icon: AllIcon,
      code: 'all',
      name: 'All',
      showNotification: true,
    },
    {
      count: 0,
      link: `/experienceDashboard/special`,
      icon: seatingNew,
      code: 'special',
      name: 'Occasions',
      showNotification: true,
    },
    {
      count: 0,
      link: `/experienceDashboard/curated`,
      icon: historyNew,
      code: 'curated',
      name: 'Events',
      showNotification: true,
    },
    {
      count: 0,
      link: `/experienceDashboard/history`,
      icon: histNew,
      code: 'history',
      name: 'History',
      showNotification: false,
    },
  ]);

  const onStatusChange = async (type, formData, id) => {
    let patch = await amApi.patch(`/expRequest/${id}`, formData);
    let iconD = [...iconData];
    let data = [...expRequests];
    data = data.filter(
      (ele) => ele._id.toString() !== patch?.data?._id.toString()
    );
    iconD[0].count -= 1;
    setExpRequests(data);
    setIconData(iconD);
    successAlert('Updated Successfully');
    getData();
    setCount(count + 1);
  };

  const getData = async () => {
    let response = await amApi.get(
      `/expRequest?status=all_pending&limit=20&page=${pageNo}`
    );
    let count = await amApi.get(`/expRequest?status=all_pending&&count=true`);
    setDataCount(count.data);
    setExpRequests(response.data.reverse());
  };

  const getByDate = () => {
    if (pageNo == 1) getData();
    else setPageNo(1);
  };

  const handlePagination = async (pageNo) => {
    setPageNo(pageNo);
  };

  useEffect(() => {
    async function fetchData() {
      let stats = await amApi.get(
        `/expRequest?status=pending&type=STATS_BY_TYPE`
      );
      let icnData = [...iconData];
      icnData[0].count = stats?.data?.[0]?.pendingCount || 0;
      icnData[1].count = stats?.data?.[0]?.allCount || 0;
      icnData[2].count = stats?.data?.[0]?.specialCount || 0;
      icnData[3].count = stats?.data?.[0]?.curatedCount || 0;
      setIconData(icnData);
    }
    if (page) {
      fetchData();
    }
  }, [page]);

  useEffect(() => {
    if (pageNo) getData();
  }, [pageNo]);

  useEffect(() => {
    // Check if expRequests is not an array or has length less than 1
    if (!expRequests || expRequests.length < 1) {
      setGroupByData({ sortOrder: [], data: {}, show: true });
      return;
    }

    let filterData = expRequests;

    if (search) {
      let searchData = new RegExp(search, 'i');
      filterData = expRequests.filter((getall) => {
        if (searchData.test(getall?.userDetails?.name)) {
          return getall;
        } else if (searchData.test(getall?.requestId)) {
          return getall;
        } else {
          return false;
        }
      });
    }

    if (paymentStatus !== '' && paymentStatus != 10) {
      filterData = filterData.filter(
        (ele) => ele.paymentStatus === paymentStatus
      );
    }

    if (paymentMethod !== '' && paymentMethod != 10) {
      filterData = filterData.filter(
        (ele) => ele?.paymentData?.paymentMethod === paymentMethod
      );
    }

    if (expStatus !== '' && expStatus != 10) {
      filterData = filterData.filter((ele) => ele?.status === expStatus);
    }

    filterData = filterDinnersByPax(filterData, paxFilter);

    let newData = _.groupBy(filterData, (data) =>
      moment(data['reservationTime']).format('ll')
    );

    for (let key in newData) {
      let data = _.groupBy(newData[key], (data) =>
        moment(data['reservationTime']).format('hh A')
      );
      let newSort = Object.keys({ ...data });
      newData[key] = { data: data, sortOrder: newSort };
    }

    let newSortOrder = Object.keys({ ...newData });
    setGroupByData({ sortOrder: newSortOrder, data: newData, show: true });
  }, [
    expRequests,
    paxFilter,
    search,
    paymentStatus,
    paymentMethod,
    expStatus,
    count,
  ]);

  /*********************************
   * @DESC Show Pax Modal Action
   *********************************/

  return (
    <React.Fragment>
      <Media query="(min-width: 992px)">
        <div className="container-fluid ">
          <div className="mt-3 d-flex justify-content-between align-items-center">
            <div className="col-6 ">
              <ExpDashboardIcons
                data={iconData}
                page={page}
                exp={null}
                history={history}
              />
            </div>
            {/* <div className="first-section d-flex align-items-center">

              <TextField
                className="calenderstd w-100"
                id="date"
                fullWidth
                label="Reservation Date"
                variant="outlined"
                InputProps={{
                  // inputProps: { min: this.state.minDate },
                }}
                type="date"
                disablePast
                minDate={new Date()}
                InputLabelProps={{
                  shrink: true,
                }}
                name="date"
                // onChange={this.onChange}
                // value={this.state.date}
              />
              <button
                type="button"
                className="enIconBtn bg-transparent mx-3"
                // onClick={() => this.onSelectDataGetReservation()}
              >
                <SVG
                  width="20px"
                  height="15px"
                  src={require("../../../../assets/images/UserManagement/right-arrow.svg")}
                  alt="seating"
                />
              </button>
            </div> */}
          </div>

          <hr />
          <div className="">
            <div className="d-flex justify-content-between align-items-center">
              <SearchBar onChange={setSearch} />
              <PaxFilter
                options={paxOptions}
                selected={paxFilter}
                setSelected={setPaxFilter}
              />
              <div className="d-flex align-items-center justify-content-end">
                <StatusFilter
                  statusfilter={false}
                  experiencestatus={
                    history?.location?.pathname?.includes('pending')
                      ? false
                      : true
                  }
                  paymentTypeFilter={true}
                  paymentMethodfilter={true}
                  paymentMethodValues={(e) => {
                    setPaymentMethod(e);
                  }}
                  paymentstatuvalues={(e) => {
                    setPaymentStatus(e);
                  }}
                  expstatusvalues={(e) => {
                    setExpStatus(e);
                  }}
                />
                <div className="f10-400" align="center">
                  <img
                    src={require('../../../../assets/images/iconButton/downloadbtn.svg')}
                    width="48px"
                  />
                </div>
              </div>
            </div>
          </div>
          <Media query="(min-width: 992px)">
            <div className="row mt-2">
              <div className={'col-12 p-0'}>
                <div className="col-12 p-0  user-table-reusable-superadmin font_16_r">
                  <Table>
                    <thead style={{ position: 'sticky', top: '2px' }}>
                      <ExperienceTableHead />
                    </thead>
                    {!expRequests ? (
                      <SmallLoader />
                    ) : !groupByData?.data ? (
                      <NoContent />
                    ) : (
                      Object.keys(groupByData.data).map((keyName, j) => (
                        <>
                          <div className="today-date-dropdown-seating-dashboard">
                            <div>
                              <h5 className="font_20_m c_red">
                                {groupByData.sortOrder[j]}
                              </h5>
                            </div>
                          </div>
                          {Object.keys(
                            groupByData.data[groupByData.sortOrder[j]]?.data
                          ).map((keyN, i) => (
                            <ListView
                              groupByData={groupByData}
                              i={i}
                              j={j}
                              page={page}
                              onStatusChange={onStatusChange}
                            />
                          ))}
                        </>
                      ))
                    )}
                  </Table>
                </div>
                {dataCount && (
                  <BasicPagination
                    totalRecords={dataCount}
                    limit={20}
                    batch={pageNo}
                    onBatchChange={(e) => handlePagination(e)}
                  />
                )}
              </div>
            </div>
          </Media>
        </div>
      </Media>
      <Media query="(max-width: 991px)">
        <div style={{ marginTop: '20%' }}>
          <div className="mb-4 container-fluid">
            <div className="overflow-auto">
              <div className="col-12  mpr-6 mobile-p-1 ">
                <ExpDashboardIcons
                  data={iconData}
                  page={page}
                  exp={null}
                  history={history}
                />
              </div>
            </div>
            <hr />
            <div className="">
              <div className="d-flex justify-content-between align-items-center">
                <SearchBar onChange={setSearch} />{' '}
              </div>
              <div className="d-flex justify-content-between align-items-center mt-1">
                <PaxFilter
                  options={paxOptions}
                  selected={paxFilter}
                  setSelected={setPaxFilter}
                />
              </div>
              <div className="d-flex align-items-center justify-content-end">
                <StatusFilter
                  statusfilter={false}
                  experiencestatus={
                    history?.location?.pathname?.includes('pending')
                      ? false
                      : true
                  }
                  paymentTypeFilter={true}
                  paymentMethodfilter={true}
                  paymentMethodValues={(e) => {
                    setPaymentMethod(e);
                  }}
                  paymentstatuvalues={(e) => {
                    setPaymentStatus(e);
                  }}
                  expstatusvalues={(e) => {
                    setExpStatus(e);
                  }}
                />
                <div className="f10-400" align="center">
                  <img
                    src={require('../../../../assets/images/iconButton/downloadbtn.svg')}
                    width="48px"
                  />
                </div>
              </div>
            </div>

            <div className="f24-500">Pending Experience requests</div>
          </div>
          <div className="mb-3" style={{ backgroundColor: '#fff2d5' }}>
            <div className="row text-center px-2 py-2 f14-500 align-items-center">
              <div className="col-4 p-0">
                Name /<br />
                Request Number
              </div>
              <div className="col-3 p-0">Total PAX</div>
              <div className="col-5 p-0">
                <p className="font_16_r">Date / Time</p>
                <p className="font_16_r">Timer</p>
                <p className="font_10_r">(DD:HH:MM:SS)</p>
              </div>
            </div>
          </div>
          <div className="px-1">
            {expRequests?.length > 0
              ? expRequests.map((expRequest) => (
                  <ExpRequestBodyCardMobile
                    expRequest={expRequest}
                    page={page}
                    onStatusChange={onStatusChange}
                    scanData={scanData}
                    key={expRequest?._id}
                    resetScan={() => {
                      console.log('Reset seating scan data.');
                      history.push({
                        pathname: '/experienceDashboard/all',
                        state: {},
                      });
                    }}
                  />
                ))
              : null}
          </div>
        </div>
      </Media>
    </React.Fragment>
  );
};

export default ExperienceDashboard;
const ListView = ({ groupByData, j, i, page, onStatusChange }) => {
  const [isOpen, setIsOpen] = useState(true);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <div className="today-date-dropdown-seating-dashboard ">
        <div>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <button
              className="accordion-button collapsed bg-danger  text-white position-absolute rounded"
              style={{
                marginRigth: 25,
                border: 'none',
              }}
              onClick={toggleAccordion}
            >
              {isOpen ? (
                <i className="fa fa-angle-up c_white" aria-hidden="true"></i>
              ) : (
                <i className="fa fa-angle-down c_white " aria-hidden="true"></i>
              )}
            </button>

            <h5 className="font_20_m c_red ml-5">
              {`${
                groupByData.data[groupByData.sortOrder[j]]?.sortOrder[i].split(
                  ' '
                )[0]
              } : 00 ${
                groupByData.data[groupByData.sortOrder[j]]?.sortOrder[i].split(
                  ' '
                )[1]
              }`}
            </h5>
          </div>
        </div>
        <div>
          <hr className="line" />
        </div>
      </div>
      {isOpen &&
        groupByData.data[groupByData.sortOrder[j]]?.data[
          groupByData.data[groupByData.sortOrder[j]]?.sortOrder[i]
        ].map((expRequest) => (
          <ExpRequestBodyCard
            expRequest={expRequest}
            page={page}
            onStatusChange={onStatusChange}
          />
        ))}
    </>
  );
};
